import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface UserUIState {
  isNotificationOpen: boolean;
  isSidebarOpen: boolean;
  toggleNotification: () => void;
  toggleSidebar: () => void;
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
  resetSidebar: () => void;
  isLoginModalOpen: boolean;
  toggleLoginModal: () => void;
  isRegisterModalOpen: boolean;
  toggleRegisterModal: () => void;
  isDepositModalOpen: boolean;
  toggleDepositModal: () => void;
  isDepositSheetOpen: boolean;
  toggleDepositSheet: () => void;
  setSelectedCategory: (category: string) => void;
  selectedCategory: string;
  isCheckboxChecked: boolean;
  toggleCheckbox: (value: boolean) => void;
  setIsAmountsLoaded: (isAmountsLoaded: boolean) => void;
  isAmountsLoaded: boolean;
  isOpenDeposit: boolean;
  setOpenDeposit: (isOpenDeposit: boolean) => void;
  isAcceptModalOpen: boolean;
  toggleAcceptModal: () => void;
  currentRaffleId: number | null;
  setCurrentRaffleId: (currentRaffleId: number) => void;
  setRegisterModalOpen: (isOpen: boolean) => void;
  setLoginModalOpen: (isOpen: boolean) => void;

  // ================== V2 ==================
  ToggleDepositV2: boolean;
  setToggleDepositV2: (ToggleDepositV2: boolean) => void;
  Alert: { message: string, type: string, show: boolean, duration: number };
  setAlert: (Alert: { message: string, type: string, show: boolean, duration: number }) => void;
  avatar: string;
  setAvatar: (avatar: string) => void;
}

export const userUIStore = create<UserUIState>()(
  persist(
    (set) => {
      return {
        isNotificationOpen: false,
        isSidebarOpen: false,
        isLoginModalOpen: false,
        isRegisterModalOpen: false,
        isDepositModalOpen: false,
        isDepositSheetOpen: false,
        selectedCategory: '',
        isCheckboxChecked: false,
        isAmountsLoaded: false,
        isOpenDeposit: false,
        isAcceptModalOpen: false,
        currentRaffleId: null,
        toggleNotification: () => { return set((state) => { return { isNotificationOpen: !state.isNotificationOpen }; }); },
        toggleSidebar: () => { return set((state) => { return { isSidebarOpen: !state.isSidebarOpen }; }); },
        setIsSidebarOpen: (isSidebarOpen: boolean) => { return set(() => { return { isSidebarOpen }; }); },
        resetSidebar: () => { return set(() => { return { isSidebarOpen: true, isNotificationOpen: false }; }); },
        toggleLoginModal: () => { return set((state) => { return { isLoginModalOpen: !state.isLoginModalOpen }; }); },
        toggleRegisterModal: () => { return set((state) => { return { isRegisterModalOpen: !state.isRegisterModalOpen }; }); },
        toggleDepositModal: () => { return set((state) => { return { isDepositModalOpen: !state.isDepositModalOpen }; }); },
        toggleDepositSheet: () => { return set((state) => { return { isDepositSheetOpen: !state.isDepositSheetOpen }; }); },
        setSelectedCategory: (category: string) => { return set(() => { return { selectedCategory: category }; }); },
        toggleCheckbox: (value: boolean) => { return set(() => { return { isCheckboxChecked: value }; }); },
        setIsAmountsLoaded: (isAmountsLoaded: boolean) => { return set(() => { return { isAmountsLoaded }; }); },
        setOpenDeposit: (isOpenDeposit: boolean) => { return set(() => { return { isOpenDeposit }; }); },
        toggleAcceptModal: () => { return set((state) => { return { isAcceptModalOpen: !state.isAcceptModalOpen }; }); },
        setCurrentRaffleId: (currentRaffleId: number) => { return set(() => { return { currentRaffleId }; }); },
        setRegisterModalOpen: (isOpen: boolean) => { return set({ isRegisterModalOpen: isOpen }); },
        setLoginModalOpen: (isOpen: boolean) => { return set({ isLoginModalOpen: isOpen }); },

        // ================== V2 ==================
        ToggleDepositV2: false,
        setToggleDepositV2: (ToggleDepositV2: boolean) => { return set(() => { return { ToggleDepositV2 }; }); },
        Alert: {
          message: '', type: 'success', show: false, duration: 3000,
        },
        setAlert: (Alert: { message: string, type: string, show: boolean, duration: number }) => { return set(() => { return { Alert }; }); },
        avatar: '',
        setAvatar: (avatar: string) => { return set(() => { return { avatar }; }); },
      };
    },
    {
      name: 'IT_userUI',
      storage: createJSONStorage(() => { return localStorage; }),
    },
  ),
);
